import React, { createContext, useState, useEffect, useContext } from 'react';
import { getSiteSettings } from '../services/settingsService';

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    siteTitle: 'أسعار الذهب',
    siteDescription: 'متابعة أسعار الذهب لحظة بلحظة مع التحليلات والأخبار.',
  });
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    setLoading(true);
    const data = await getSiteSettings();
    if (data) {
      setSettings(data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, refetchSettings: fetchSettings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
};
